export const STORAGE_LOCATION = 'earthmonitor-location';

export interface SavedLocation {
  lat: number;
  lng: number;
  updatedAt: number;
}

export function loadSavedLocation(): SavedLocation | null {
  try {
    const raw = localStorage.getItem(STORAGE_LOCATION);
    if (!raw) return null;
    const o = JSON.parse(raw) as SavedLocation;
    if (
      typeof o.lat === 'number' &&
      typeof o.lng === 'number' &&
      !Number.isNaN(o.lat) &&
      !Number.isNaN(o.lng)
    ) {
      return o;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function saveUserLocation(lat: number, lng: number): void {
  try {
    const payload: SavedLocation = {
      lat,
      lng,
      updatedAt: Date.now(),
    };
    localStorage.setItem(STORAGE_LOCATION, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

export function clearSavedLocation(): void {
  try {
    localStorage.removeItem(STORAGE_LOCATION);
  } catch {
    /* ignore */
  }
}

export function requestBrowserLocation(): Promise<{ lat: number; lng: number }> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation not supported'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        resolve({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        });
      },
      (err) => reject(err),
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 60000 }
    );
  });
}
